import { render, staticRenderFns } from "./PdfDocumentCanvas.vue?vue&type=template&id=cf70c9ba&scoped=true&"
import script from "./PdfDocumentCanvas.vue?vue&type=script&lang=js&"
export * from "./PdfDocumentCanvas.vue?vue&type=script&lang=js&"
import style0 from "./PdfDocumentCanvas.vue?vue&type=style&index=0&id=cf70c9ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf70c9ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VAlert,VBtn})
